import React from "react";

export default function SQLServer_GETDATE() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_GETDATE</h1>
      <p>This is the SQLServer_GETDATE component generated from the SQL JSON.</p>
    </div>
  );
}
